import { useState } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { AUTH_API } from '@/shared/api/amplify';
import { setCognitoUserAuthorized, setCognitoUserMetadata } from '@/shared/store-tmp/CognitoSlice';
import { inIframe } from '@/shared/lib/utils';
import { useAppDispatch } from './reduxToolkitHooks';
import { useExecuteOneTime } from './useExecuteOneTime';

export const useCheckIsUserAuthorized = (onUserAuthorized?: () => void) => {
  const dispatch = useAppDispatch();
  const [isUserAuthorizedChecking, setIsUserAuthorizedChecking] = useState(true);

  useExecuteOneTime(async () => {
    if (inIframe()) {
      dispatch(setCognitoUserAuthorized());
    } else {
      try {
        // TODO: type needs to be corrected
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const response: CognitoUser = await AUTH_API.checkUser();
        const idToken = response?.getSignInUserSession()?.getIdToken();
        const token = idToken?.getJwtToken();

        if (token) {
          dispatch(setCognitoUserAuthorized());

          const metadata = {
            // TODO: type needs to be corrected after Amplify Lib update
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            picture: idToken?.payload.picture,
            // TODO: type needs to be corrected after Amplify Lib update
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            name: idToken?.payload.name,
            // TODO: type needs to be corrected after Amplify Lib update
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            emailVerified: idToken?.payload.email_verified,
            isUsedSocialProviders: Boolean(idToken?.payload.identities?.length),
            // TODO: type needs to be corrected after Amplify Lib update
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            cognitoId: idToken?.payload.sub,
          };

          dispatch(setCognitoUserMetadata(metadata));

          onUserAuthorized?.();
        }

        // we need a catch block, because if a user is not authorized, there will be an error here
        // eslint-disable-next-line no-empty
      } catch {}
    }

    setIsUserAuthorizedChecking(false);
  });

  return {
    isUserAuthorizedChecking,
  };
};
